import { Autorenew as AutorenewIcon } from '@mui/icons-material';
import { Box, CardMedia, styled } from '@mui/material';

export const Wrapper = styled(Box)(
  () => `
    & .MuiInputLabel-root {
      margin-bottom: 10px;
      font-weight: 400;
    }
  `,
);

export const ImagePreview = styled(CardMedia)`
  min-height: 150px;
  min-width: 150px;
`;
export const AutorenewIconStyled = styled(AutorenewIcon)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
